// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1___84447056d0264fe6e5d{/*!*/}.AuthorHeader-cls2__e0f23384c133f6f8c543{color:#fff;background-color:rgba(0,0,0,.59);clip-path:circle(48% at 50% 50%);position:absolute;inset:.5px;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1___84447056d0264fe6e5d",
	"cls2": "AuthorHeader-cls2__e0f23384c133f6f8c543 AuthorHeader-cls1___84447056d0264fe6e5d"
};
export default ___CSS_LOADER_EXPORT___;
